import React from 'react';
import {
  CheckCircle,
  CreditCard,
  Calendar,
  FileText,
  Home,
} from 'lucide-react';
import '../../styles/PaymentSuccess.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatDateWithAmPm } from '../../Style';
import CustomButton from '../../component/ui/FormFields/Button';
import { useSelector } from 'react-redux';
import { BOOKINGS, DASHBOARD } from '../../component/common/Routes/AppRoutes';
import {
  VENDOR_BOOKINGS,
  VENDOR_DASHBOARD,
} from '../../component/common/Routes/VendorRoutes';
import {
  CUSTOMER_BOOKINGS,
  CUSTOMER_DASHBOARD,
} from '../../component/common/Routes/CustomerRoutes';

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const orderDetails = location.state?.orderData || {};
  const { user } = useSelector((state) => state.auth);
  console.log('orderDetails', orderDetails);
  const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
  });
  return (
    <div className='payment-success-container'>
      <div className='payment-card'>
        {/* Success Header */}
        <div className='success-header'>
          <div className='icon-container'>
            <CheckCircle size={56} strokeWidth={2.5} />
          </div>
          <h1>Payment Successful!</h1>
        </div>

        {/* Content */}
        <div className='content'>
          <p className='success-message'>
            Thank you for your purchase. Your payment has been processed
            successfully.
          </p>

          {/* Transaction Details */}
          <div className='transaction-details'>
            <h2>Transaction Details</h2>

            <div className='detail-row'>
              <div className='detail-label'>
                <FileText size={18} />
                <span>Transaction ID</span>
              </div>
              <span className='detail-value transaction-id'>TXN123456789</span>
            </div>
            <div className='detail-row'>
              <div className='detail-label'>
                <CreditCard size={18} />
                <span>PNR NUMBER</span>
              </div>
              <span className='detail-value amount'>
                {orderDetails?.pnr_number}
              </span>
            </div>
            <div className='detail-row'>
              <div className='detail-label'>
                <CreditCard size={18} />
                <span>Amount</span>
              </div>
              <span className='detail-value amount'>
                {currencyFormatter.format(parseFloat(orderDetails?.total))}
              </span>
            </div>

            <div className='detail-row'>
              <div className='detail-label'>
                <Calendar size={18} />
                <span>Date</span>
              </div>
              <span className='detail-value'>
                {formatDateWithAmPm(orderDetails?.created_at)}
              </span>
            </div>

            {/* <div className='detail-row'>
              <div className='detail-label'>
                <CreditCard size={18} />
                <span>Payment Method</span>
              </div>
              <div className='card-info'>
                <span>Visa</span>
                <span className='card-number'>•••• 4242</span>
              </div>
            </div> */}
          </div>

          {/* <div className="receipt-notification">
            <p>
              A receipt has been sent to your email address. Please check your
              inbox.
            </p>
          </div> */}

          {/* Action Buttons */}
          {/* <div className='action-buttons'>
            <button className='btn primary'>
              <FileText size={18} />
              <span>View Payment Details</span>
            </button>
            <button className='btn secondary'>
              <Home size={18} />
              <span>Return to Dashboard</span>
            </button>
          </div> */}
          <div className='action-buttons'>
            <CustomButton
              variant='contained'
              className='cancel-button'
              type='button'
              text='View Bookings'
              onClick={() => {
                let bookingsRoute;

                if (user.role === 'Admin' || user.role === 'Staff') {
                  bookingsRoute = BOOKINGS;
                } else if (user.role === 'Vendor') {
                  bookingsRoute = VENDOR_BOOKINGS;
                } else if (user.role === 'Customer') {
                  bookingsRoute = CUSTOMER_BOOKINGS;
                }
                navigate(bookingsRoute);
              }}

              // onClick={() => navigate()}
            />
            <CustomButton
              variant='contained'
              className='success-button'
              type='button'
              text={'Return to Dashboard'}
              onClick={() => {
                let dashboardRoute;

                if (user.role === 'Admin' || user.role === 'Staff') {
                  dashboardRoute = DASHBOARD;
                } else if (user.role === 'Vendor') {
                  dashboardRoute = VENDOR_DASHBOARD;
                } else if (user.role === 'Customer') {
                  dashboardRoute = CUSTOMER_DASHBOARD;
                }
                navigate(dashboardRoute);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
